import { createContext } from "react";

const Globalcontext = createContext();

export default Globalcontext;
